import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ModalRef, ModalService } from '@core-lib/modules/modal-container';
import { TokenExpiredModalComponent } from "../components/token-expired-modal.component";

@Injectable({
    providedIn: 'root'
  })
  export class AuthNotificationService {
    private modalRef: ModalRef;
  
    constructor(
        private router: Router,
        private modalService: ModalService
    ) { }
  
    showTokenExpiredNotification(callback: () => void) {
        this.modalRef = this.modalService.show(TokenExpiredModalComponent);
        this.modalRef.content.onClose.subscribe(() => {
          callback();
        });
      }
  }